// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2TdJt","consentsList":"PatientConsents_consentsList__1rXch","consentsListEmpty":"PatientConsents_consentsListEmpty__1SHeU"};